/**
 * This code is ugly, but performs really well according to a person on StackOverflow https://stackoverflow.com/questions/9229645/remove-duplicate-values-from-js-array
 * Removes duplicates vehicles in an array
 * @param {array of vehicles} array 
 * @returns {array of vehicles without duplicates}
 */
export const getUniqueVehicles = (array) => {
  var seen = {};
  var out = [];
  var len = array.length;
  var j = 0;
  for (var i = 0; i < len; i++) {
    var current = array[i];
    var vehicle = current.item.PlateText ?? current.item.Text;
    if (seen[vehicle] !== 1) {
      seen[vehicle] = 1;
      out[j++] = current;
    }
  }
  return out;
}

// export const shouldAccountBeUpdated = (context) => true;
export const shouldAccountBeUpdated = (context) => isLtp(context) && (context.episerver.shouldUpdateAccount === true || context.episerver.shouldUpdateAccount === "true");
export const isLtp = (context) => +context.episerver.productType === 1;
export const isStp = (context) => !isLtp(context);

/**
 * A console.log() with a label
 * @param {string} label 
 * @param {any} val 
 */
export const prettyLog = (label, val) => {
  console.log("%c" + label, 'color: #fff; background: #245057; padding: 0.2rem 1.5rem;');
  console.log(val);
}
